import React from 'react'

import Browser from './browser'
import CheckRow from './check-row'
import * as check from './check'
import SpeedTest from './speedofme-wrapper'

/**
 * Where the meat of the layout happens. This
 * Component handles all of the layout for the
 * app, and at somepoint, might also be where
 * app state would be stored.
 */
export default class CompatibilityTable extends React.Component {
  render() {
    return (
      <div>
        <table>
          <thead>
            <tr>
              <th colSpan={4}>If you pass all checks listed below, you should be able to use the main features used in our online courses.</th>
            </tr>
          </thead>
          <tbody>
            <Browser />
            <CheckRow name="JavaScript"
                      checkFeature={check.javascript}/>
            <CheckRow name="Cookies"
                      checkFeature={check.cookies} />
            <CheckRow name="Popups"
                      checkFeature={check.popups} />
            <CheckRow name="Adobe Flash"
                      checkFeature={check.flash} />
            <CheckRow name="HTTP"
                      checkFeature={check.http} />
          </tbody>
        </table>
        <SpeedTest />
      </div>)
  }
}


// WEBPACK FOOTER //
// ./app/compatibility-table.js